"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./BaseSelectedItemsList"), exports);
tslib_1.__exportStar(require("./SelectedPeopleList/SelectedPeopleList"), exports);
tslib_1.__exportStar(require("./SelectedPeopleList/Items/ExtendedSelectedItem"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/SelectedItemsList/index.js
// module id = 1148
// module chunks = 0